import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGauge = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_575_4059)",
		children: [/* @__PURE__ */ _jsx("mask", {
			id: "mask0_575_4059",
			style: { maskType: "luminance" },
			maskUnits: "userSpaceOnUse",
			x: 0,
			y: 0,
			width: 32,
			height: 32,
			children: /* @__PURE__ */ _jsx("path", {
				d: "M31.746 0.46582H0.253906V31.5283H31.746V0.46582Z",
				fill: "white"
			})
		}), /* @__PURE__ */ _jsxs("g", {
			mask: "url(#mask0_575_4059)",
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M27.5053 27.9725H4.49518C3.23627 27.9725 2.09931 27.2433 1.59794 26.1147C0.686836 24.0583 0.235143 21.8767 0.254503 19.6292C0.328058 11.3027 7.153 4.30549 15.4685 4.0319C19.795 3.87381 23.8557 5.45924 26.9484 8.45195C30.0418 11.446 31.746 15.4647 31.746 19.7692C31.746 21.969 31.293 24.1047 30.3999 26.1173C29.8999 27.2446 28.7636 27.9725 27.5053 27.9725ZM16.0041 5.34435C15.8402 5.34435 15.6763 5.34694 15.5124 5.35207C7.8951 5.60375 1.64311 12.0131 1.576 19.6408C1.55794 21.6986 1.97156 23.6963 2.80588 25.5785C3.09496 26.2296 3.75828 26.651 4.49518 26.651H27.5053C28.2416 26.651 28.9036 26.2309 29.192 25.5811C30.0095 23.7389 30.4245 21.7831 30.4245 19.7692C30.4245 15.826 28.8636 12.1441 26.0289 9.40174C23.3143 6.77429 19.7705 5.34435 16.0041 5.34435Z",
				fill: "currentColor"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M17.1362 22.9232C16.3899 24.0022 15.1959 24.4697 14.4693 23.9672C13.7427 23.4647 13.7586 22.1825 14.5048 21.1035C15.251 20.0244 23.3421 9.58342 24.0688 10.0859C24.7954 10.5884 17.8824 21.844 17.1362 22.9232Z",
				fill: "currentColor"
			})]
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_575_4059",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 32,
			height: 32,
			fill: "white"
		})
	}) })]
});
export default SvgGauge;
